<markdown ngPreserveWhitespaces [data]="markdown" (ready)="onReady">
</markdown>
